export default {
  backPreviousPageTxt: '返回上一级'
}


// WEBPACK FOOTER //
// ./src/config/lang/zh-CN/system.js